import PropTypes from "prop-types";
import React from "react";
import useResendOTP from "./hooks/resendOTP";

function ResendOTP({ renderTime, renderButton, style, className, ...props }) {
    const { remainingTime, handelResendClick } = useResendOTP(props);
    return (
        <div
            className={className || ""}
            data-testid="otp-resend-root"
        >
            {renderTime ? (
                renderTime(remainingTime)
            ) : (
                <span>{remainingTime} sec</span>
            )}
            {renderButton ? (
                renderButton({
                    disabled: remainingTime !== 0,
                    onClick: handelResendClick,
                    remainingtime: remainingTime // if you want to access time on button use small case "remainingtime"
                })
            ) : (
                <button disabled={remainingTime !== 0} onClick={handelResendClick} type="button">
                    Resend Verification Code
                </button>
            )}
        </div>
    );
}

ResendOTP.defaultProps = {
    maxTime: 30,
    timeInterval: 1000,
    style: {}
};

ResendOTP.propTypes = {
    onTimerComplete: PropTypes.func,
    onResendClick: PropTypes.func,
    renderTime: PropTypes.func,
    renderButton: PropTypes.func,
    maxTime: PropTypes.number,
    timeInterval: PropTypes.number,
    style: PropTypes.object,
    className: PropTypes.string
};

export default ResendOTP;